const DOCUMENT_STEP_ID = 'document'
const EMAIL_STEP_ID = 'email'
const TWO_FACTOR_AUTHENTICATION_STEP_ID = 'two_factor_authentication'

const STEPS = (isFirstAccess) => [
  {
    id: DOCUMENT_STEP_ID,
    video: { title: '', url: 'https://player.vimeo.com/video/1182048539' },
    text: `Bem-vindo ao Portal de Fornecedores. Para começar, precisamos identificar sua empresa. Informe o CNPJ para prosseguir.`,
    stepMixpanel: 'validacao_documento-jornada_fornecedor',
  },
  {
    id: EMAIL_STEP_ID,
    video: { title: '', url: 'https://player.vimeo.com/video/1182048505' },
    text: isFirstAccess
      ? `Ótimo! Encontramos o cadastro da sua empresa. Confirme a razão social e informe o e-mail para contato para continuar.`
      : `Ótimo! Encontramos o cadastro da sua empresa. Confirme o e-mail para continuar.`,
    stepMixpanel: 'validacao_email-jornada_fornecedor',
  },
  {
    id: TWO_FACTOR_AUTHENTICATION_STEP_ID,
    video: { title: '', url: 'https://player.vimeo.com/video/1182048488' },
    text: `Quase lá! Para garantir a segurança do seu acesso, enviamos um código de verificação para o e-mail informado. Digite o código recebido para entrar no portal.`,
    stepMixpanel: 'validacao_dois_fatores-jornada_fornecedor',
  },
]

export default {
  DOCUMENT_STEP_ID,
  EMAIL_STEP_ID,
  STEPS,
  TWO_FACTOR_AUTHENTICATION_STEP_ID,
}
